export const useRoleArray = () => {
  /**
   * Checks if the an array has the specified roles.
   *
   * @param roles - The array of all roles to check from.
   * @param rolesToCheck - An array of roles to check. (also accepts part of a role e.g. 'ADMIN_' will match 'ADMIN_USER')
   * @param all - Optional. If true, checks if all roles are present. If false, checks if at least one role is present. Default is true.
   * @returns True if the user has the specified roles, false otherwise.
   */
  const checkRoleArray = (
    roles: string[],
    rolesToCheck: string[],
    all = true
  ) => {
    if (all) {
      // Check if all roles are present
      return rolesToCheck.every((r) => roles.some((role) => role.includes(r)))
    } else {
      // Check if at least one role is present
      return rolesToCheck.some((r) => roles.some((role) => role.includes(r)))
    }
  }

  return { checkRoleArray }
}
